import { styled } from "styled-components";

export const DashboardGridItem = styled.div<{ doubleSpan?: boolean }>`
  grid-column: span ${({ doubleSpan }) => (doubleSpan ? 2 : 1)};
  padding: ${({ theme }) => theme.SPACING.XL};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.SM};
  border: 1px solid ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
  display: flex;
  flex-direction: ${({ doubleSpan }) => (doubleSpan ? "row" : "column")};
  gap: ${({ theme }) => theme.SPACING.LG} ${({ theme }) => theme.SPACING.XL};
  flex-wrap: ${({ doubleSpan }) => (doubleSpan ? "wrap" : "initial")};

  @media (max-width: ${({ theme }) => theme.BREAKPOINTS.LG}) {
    grid-column: span 1;
  }
`;

export const DoubleSpanGridContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.SPACING.LG};
  flex: 1 0 20rem;
`;
